(function () {
  'use strict';

  var VIEW_KEY = 'b2b-view-mode';
  var ajaxSectionId = window.b2bAjaxSectionId || 'zpro-b2b-collection-ajax';
  var searchSectionId = window.b2bSearchSectionId || 'zpro-b2b-search-ajax';
  var productCardSectionId = window.b2bProductCardSectionId || 'zpro-b2b-product-card-ajax';
  var collectionUrl = window.b2bCollectionUrl || window.location.pathname;
  var collectionHandle = window.b2bCollectionHandle || '';
  var collectionProductIds = null;
  var collectionSearchIndex = [];
  var collectionSearchIndexPromise = null;
  var moneyFormat = window.b2bMoneyFormat || '${{amount}}';
  var currencySymbol = window.b2bCurrencySymbol || '$';
  var currencyRate = (function () {
    var candidates = [
      window.b2bCurrencyRate,
      window.Shopify && window.Shopify.currency && window.Shopify.currency.rate
    ];
    for (var i = 0; i < candidates.length; i++) {
      var rate = Number(candidates[i]);
      if (rate && isFinite(rate) && rate > 0) return rate;
    }
    return 1;
  })();
  var moqCents = (Number(window.b2bMoqAmount) || 30000) * currencyRate;
  var currentDiscountCode = null;
  var checkoutInFlight = false;
  var activeDetailCard = null;
  var detailMainFlkty = null;
  var searchTimer = null;
  var searchAbort = null;
  var searchRequestId = 0;

  function getDetailOverlay() {
    return document.getElementById('b2b-detail-overlay');
  }

  function getDetailPane() {
    var overlay = getDetailOverlay();
    return overlay ? overlay.querySelector('.b2b-detail-pane') : null;
  }

  function getDetailPaneContent() {
    return document.querySelector('[data-b2b-detail-pane-content]');
  }

  function getPoQtyForVariant(variantId) {
    var container = getPoItems();
    if (!container) return 0;
    var item = container.querySelector('[data-b2b-added-id="' + variantId + '"]');
    return item ? parseInt(item.getAttribute('data-b2b-added-qty'), 10) || 0 : 0;
  }

  function syncDetailPaneQty(paneContent, variantId) {
    if (!paneContent) return;
    var qty = getPoQtyForVariant(variantId);
    paneContent.querySelectorAll('[data-b2b-detail-variant-panel]').forEach(function (panel) {
      var isActive = panel.getAttribute('data-b2b-variant-id') === String(variantId);
      panel.classList.toggle('is-active', isActive);
      panel.classList.toggle('has-qty', isActive && qty > 0);
      if (isActive) {
        var qtyVal = panel.querySelector('[data-b2b-detail-qty-val]');
        if (qtyVal) qtyVal.textContent = String(qty);
      }
    });
  }

  function destroyDetailGallery() {
    if (detailMainFlkty) {
      try {
        detailMainFlkty.destroy();
      } catch (e) {}
      detailMainFlkty = null;
    }
  }

  function findSlideIndexByImage(paneContent, imageSrc) {
    if (!paneContent || !imageSrc) return 0;
    var slides = paneContent.querySelectorAll('[data-b2b-detail-slide]');
    var matched = 0;
    var imageFile = imageSrc.split('?')[0].split('/').pop();
    slides.forEach(function (slide, i) {
      var src = slide.getAttribute('data-b2b-media-src') || '';
      var slideFile = src.split('?')[0].split('/').pop();
      if (src === imageSrc || (imageFile && slideFile && imageFile === slideFile) || imageSrc.indexOf(slideFile) !== -1) {
        matched = i;
      }
    });
    return matched;
  }

  function syncDetailThumbs(paneContent, index) {
    if (!paneContent) return;
    paneContent.querySelectorAll('[data-b2b-detail-thumb]').forEach(function (thumb, i) {
      thumb.classList.toggle('is-active', i === index);
    });
  }

  function setDetailSlide(paneContent, index) {
    if (!paneContent) return;
    if (detailMainFlkty) {
      detailMainFlkty.select(index);
      syncDetailThumbs(paneContent, index);
      return;
    }
    var slides = paneContent.querySelectorAll('[data-b2b-detail-slide]');
    slides.forEach(function (slide, i) {
      slide.classList.toggle('is-active', i === index);
    });
    syncDetailThumbs(paneContent, index);
  }

  function setDetailSlideByImage(paneContent, imageSrc) {
    setDetailSlide(paneContent, findSlideIndexByImage(paneContent, imageSrc));
  }

  function initDetailGallery(paneContent, initialIndex) {
    destroyDetailGallery();
    if (!paneContent) return;

    var main = paneContent.querySelector('[data-b2b-detail-main]');
    var slides = main ? main.querySelectorAll('[data-b2b-detail-slide]') : [];
    var startIndex = initialIndex || 0;

    if (!main || slides.length === 0) return;

    if (typeof Flickity === 'undefined' || slides.length === 1) {
      setDetailSlide(paneContent, startIndex);
      return;
    }

    detailMainFlkty = new Flickity(main, {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      draggable: true,
      wrapAround: false,
      percentPosition: true,
      initialIndex: startIndex
    });

    syncDetailThumbs(paneContent, startIndex);

    detailMainFlkty.on('select', function () {
      syncDetailThumbs(paneContent, detailMainFlkty.selectedIndex);
    });

    requestAnimationFrame(function () {
      if (detailMainFlkty) detailMainFlkty.resize();
    });
  }

  function activateDetailVariant(paneContent, variantId, card) {
    if (!paneContent) return;
    var select = paneContent.querySelector('[data-b2b-detail-variant-select]');
    if (select && select.value !== String(variantId)) {
      select.value = String(variantId);
    }
    var option = select ? select.querySelector('option[value="' + variantId + '"]') : null;
    if (option) {
      var variantImage = option.getAttribute('data-b2b-image');
      if (variantImage) setDetailSlideByImage(paneContent, variantImage);
    }
    var cartVariantId =
      (option && option.getAttribute('data-b2b-cart-variant-id')) || String(variantId);
    syncDetailPaneQty(paneContent, cartVariantId);
    if (card) activateVariant(card, variantId, true);
  }

  function openB2bDetail(handle, card) {
    var source = document.querySelector('[data-b2b-detail-content="' + handle + '"]');
    var overlay = getDetailOverlay();
    var pane = getDetailPane();
    var paneContent = getDetailPaneContent();
    if (!source || !overlay || !pane || !paneContent) return;

    destroyDetailGallery();
    paneContent.innerHTML = source.innerHTML;
    activeDetailCard = card || document.querySelector('[data-b2b-product-handle="' + handle + '"]');

    var panel = activeDetailCard ? getActiveVariantPanel(activeDetailCard) : null;
    var cartVariantId = panel ? panel.getAttribute('data-b2b-variant-id') : null;
    var cardSelect = activeDetailCard ? activeDetailCard.querySelector('[data-b2b-variant-select]') : null;
    var colorVariantId = cardSelect && cardSelect.value ? cardSelect.value : cartVariantId;
    var initialIndex = 0;

    if (colorVariantId || cartVariantId) {
      var select = paneContent.querySelector('[data-b2b-detail-variant-select]');
      if (select && colorVariantId) select.value = String(colorVariantId);
      var option = select
        ? select.querySelector('option[value="' + (colorVariantId || '') + '"]') ||
          select.options[select.selectedIndex]
        : null;
      if (option) {
        var variantImage = option.getAttribute('data-b2b-image');
        if (variantImage) initialIndex = findSlideIndexByImage(paneContent, variantImage);
        cartVariantId = option.getAttribute('data-b2b-cart-variant-id') || cartVariantId;
      }
      if (cartVariantId) syncDetailPaneQty(paneContent, cartVariantId);
    }

    overlay.hidden = false;
    document.body.classList.add('b2b-detail-open');
    requestAnimationFrame(function () {
      pane.classList.add('is-active');
      initDetailGallery(paneContent, initialIndex);
    });
  }

  function closeB2bDetail() {
    var overlay = getDetailOverlay();
    var pane = getDetailPane();
    var paneContent = getDetailPaneContent();
    if (!overlay || !pane) return;

    pane.classList.remove('is-active');
    document.body.classList.remove('b2b-detail-open');
    activeDetailCard = null;
    destroyDetailGallery();

    setTimeout(function () {
      overlay.hidden = true;
      if (paneContent) paneContent.innerHTML = '';
    }, 300);
  }

  function syncOpenDetailPane() {
    if (!activeDetailCard) return;
    var paneContent = getDetailPaneContent();
    if (!paneContent || !paneContent.innerHTML) return;
    var panel = getActiveVariantPanel(activeDetailCard);
    if (panel) syncDetailPaneQty(paneContent, panel.getAttribute('data-b2b-variant-id'));
  }

  function formatMoney(cents) {
    var amount = (Number(cents) || 0) / 100;
    var formatted = amount.toFixed(2);
    if (moneyFormat.indexOf('{{amount_no_decimals}}') !== -1) {
      formatted = String(Math.round(amount));
    }
    return currencySymbol + formatted;
  }

  function getShell() {
    return document.querySelector('[data-b2b-shell]');
  }

  function getProductsRoot() {
    return document.querySelector('[data-b2b-products]');
  }

  function getPoItems() {
    return document.getElementById('b2b-po-items');
  }

  function setView(mode) {
    var root = getProductsRoot();
    if (!root) return;
    root.classList.remove('b2b-view-grid', 'b2b-view-list');
    root.classList.add(mode === 'list' ? 'b2b-view-list' : 'b2b-view-grid');

    document.querySelectorAll('[data-b2b-view]').forEach(function (btn) {
      var active = btn.getAttribute('data-b2b-view') === mode;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    try {
      localStorage.setItem(VIEW_KEY, mode);
    } catch (e) {}
  }

  function restoreView() {
    var mode = 'list';
    try {
      mode = localStorage.getItem(VIEW_KEY) || 'list';
    } catch (e) {}
    setView(mode);
  }

  function applyInStockFilter() {
    var toggle = document.getElementById('b2b-in-stock-only');
    var onlyInStock = toggle ? toggle.checked : false;
    document.querySelectorAll('.b2b-product').forEach(function (card) {
      var available = card.getAttribute('data-b2b-available') === 'true';
      card.classList.toggle('is-hidden-stock', onlyInStock && !available);
    });
  }

  function openFilters() {
    var drawer = document.getElementById('b2b-filter-drawer');
    if (!drawer) return;
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeFilters() {
    var drawer = document.getElementById('b2b-filter-drawer');
    if (!drawer) return;
    drawer.hidden = true;
    document.body.style.overflow = '';
  }

  function buildSectionUrl(url) {
    var u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', ajaxSectionId);
    return u.toString();
  }

  function replaceAjaxParts(html) {
    var temp = document.createElement('div');
    temp.innerHTML = html;
    var stockToggle = document.getElementById('b2b-in-stock-only');
    var stockWasOn = stockToggle ? stockToggle.checked : false;

    var newCatalog = temp.querySelector('.b2b-ajax-catalog');
    var currentCatalog = document.querySelector('[data-b2b-catalog]');
    if (newCatalog && currentCatalog) {
      if (activeDetailCard) closeB2bDetail();
      currentCatalog.innerHTML = newCatalog.innerHTML;
    }

    var newToolbar = temp.querySelector('.b2b-ajax-toolbar');
    var currentToolbar = document.querySelector('.b2b-toolbar');
    if (newToolbar && currentToolbar) {
      currentToolbar.replaceWith(newToolbar);
      var stockNew = document.getElementById('b2b-in-stock-only');
      if (stockNew) stockNew.checked = stockWasOn;
    }

    var newFilters = temp.querySelector('.b2b-filter-drawer');
    var currentFilters = document.getElementById('b2b-filter-drawer');
    if (newFilters && currentFilters) {
      var wasOpen = !currentFilters.hidden;
      currentFilters.replaceWith(newFilters);
      if (wasOpen) {
        openFilters();
      }
    }

    restoreView();
    applyInStockFilter();
    syncCardsFromPo();
  }

  function fetchCollection(url, pushState) {
    var requestUrl = buildSectionUrl(url);
    return fetch(requestUrl)
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to load collection');
        return res.text();
      })
      .then(function (html) {
        replaceAjaxParts(html);
        if (pushState !== false) {
          var clean = new URL(url, window.location.origin);
          clean.searchParams.delete('section_id');
          history.pushState({ b2b: true }, '', clean.pathname + clean.search);
        }
      })
      .catch(function (err) {
        console.error(err);
      });
  }

  function getActiveVariantPanel(card) {
    return card.querySelector('.b2b-product__variant-panel.is-active');
  }

  function getCartVariantId(el, fallbackId) {
    if (!el) return String(fallbackId || '');
    return el.getAttribute('data-b2b-cart-variant-id') || String(fallbackId || '');
  }

  function resolveCardColorSelection(card, colorVariantId) {
    var select = card.querySelector('[data-b2b-variant-select]');
    var option = select ? select.querySelector('option[value="' + colorVariantId + '"]') : null;
    if (option) {
      return {
        image: option.getAttribute('data-b2b-image'),
        cartVariantId: getCartVariantId(option, colorVariantId)
      };
    }

    var swatch = card.querySelector('[data-b2b-swatch][data-b2b-variant-id="' + colorVariantId + '"]');
    if (swatch) {
      return {
        image: swatch.getAttribute('data-b2b-image'),
        cartVariantId: getCartVariantId(swatch, colorVariantId)
      };
    }

    return {
      image: null,
      cartVariantId: String(colorVariantId || '')
    };
  }

  function setCardThumbnail(card, imageSrc) {
    var img = card.querySelector('img.b2b-product__image');
    if (!img || !imageSrc) return;
    img.src = imageSrc;
    img.removeAttribute('srcset');
  }

  function activateVariant(card, variantId, skipDetailSync) {
    var selection = resolveCardColorSelection(card, variantId);
    var cartVariantId = selection.cartVariantId || String(variantId);

    card.querySelectorAll('[data-b2b-variant-panel]').forEach(function (panel) {
      panel.classList.toggle('is-active', panel.getAttribute('data-b2b-variant-id') === String(cartVariantId));
    });

    card.querySelectorAll('[data-b2b-swatch]').forEach(function (swatch) {
      swatch.classList.toggle('is-active', swatch.getAttribute('data-b2b-variant-id') === String(variantId));
    });

    var select = card.querySelector('[data-b2b-variant-select]');
    if (select && select.value !== String(variantId)) {
      select.value = String(variantId);
    }

    var imageSrc = selection.image;
    if (!imageSrc) {
      var activeSwatch = card.querySelector('[data-b2b-swatch].is-active');
      if (activeSwatch) imageSrc = activeSwatch.getAttribute('data-b2b-image');
    }
    if (!imageSrc && select && select.options[select.selectedIndex]) {
      imageSrc = select.options[select.selectedIndex].getAttribute('data-b2b-image');
    }
    setCardThumbnail(card, imageSrc);

    syncCardSelectedState(card);

    if (!skipDetailSync && activeDetailCard === card) {
      var paneContent = getDetailPaneContent();
      if (paneContent && paneContent.innerHTML) {
        activateDetailVariant(paneContent, variantId, null);
      }
    }
  }

  function syncCardSelectedState(card) {
    var panel = getActiveVariantPanel(card);
    if (!panel) {
      card.classList.remove('is-selected');
      return;
    }
    var input = panel.querySelector('[data-b2b-qty]');
    var qty = input ? parseInt(input.value, 10) || 0 : 0;
    card.classList.toggle('is-selected', qty > 0);
    var qtyWrap = panel.querySelector('.b2b-product__qty');
    if (qtyWrap) qtyWrap.hidden = qty <= 0;
  }

  function updatePoItem(variantId, qty, fallback) {
    var container = getPoItems();
    if (!container) return;

    var existing = container.querySelector('[data-b2b-added-id="' + variantId + '"]');
    qty = parseInt(qty, 10) || 0;

    if (existing) {
      if (qty <= 0) {
        existing.remove();
      } else {
        existing.setAttribute('data-b2b-added-qty', String(qty));
        var qtyVal = existing.querySelector('.b2b-po-item__qty-val');
        if (qtyVal) qtyVal.textContent = String(qty);
      }
    } else if (qty > 0) {
      var template = document.querySelector(
        '[data-b2b-variant-panel][data-b2b-variant-id="' + variantId + '"] .b2b-po-template'
      );
      if (template) {
        container.insertAdjacentHTML('beforeend', template.innerHTML);
      } else if (fallback) {
        container.insertAdjacentHTML('beforeend', buildFallbackPoItemHtml(variantId, qty, fallback));
      }

      var rows = container.querySelectorAll('[data-b2b-added-id="' + variantId + '"]');
      var added = rows.length ? rows[rows.length - 1] : null;
      if (added) {
        added.setAttribute('data-b2b-added-qty', String(qty));
        var qtyValNew = added.querySelector('.b2b-po-item__qty-val');
        if (qtyValNew) qtyValNew.textContent = String(qty);
      }
    }

    syncCardsFromPo();
    calculatePo();
    syncOpenDetailPane();
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function buildFallbackPoItemHtml(variantId, qty, data) {
    var title = escapeHtml(data.title || 'Product');
    var image = data.image ? '<img src="' + escapeHtml(data.image) + '" alt="" width="48" height="48" loading="lazy">' : '';
    var price = parseInt(data.price, 10) || 0;
    var compare = parseInt(data.compare, 10) || 0;
    return (
      '<div class="b2b-po-item" data-b2b-added-id="' +
      variantId +
      '" data-b2b-added-qty="' +
      qty +
      '" data-b2b-price="' +
      price +
      '" data-b2b-compare="' +
      compare +
      '">' +
      '<div class="b2b-po-item__img">' +
      image +
      '</div>' +
      '<div class="b2b-po-item__meta">' +
      '<div class="b2b-po-item__title">' +
      title +
      '</div>' +
      '<div class="b2b-po-item__price" data-b2b-line-price>' +
      formatMoney(price) +
      '</div>' +
      '</div>' +
      '<div class="b2b-po-item__controls">' +
      '<div class="b2b-po-item__qty">' +
      '<button type="button" class="b2b-po-item__qty-btn" data-b2b-po-qty="dec" aria-label="Decrease">−</button>' +
      '<span class="b2b-po-item__qty-val">' +
      qty +
      '</span>' +
      '<button type="button" class="b2b-po-item__qty-btn" data-b2b-po-qty="inc" aria-label="Increase">+</button>' +
      '</div>' +
      '<button type="button" class="b2b-po-item__remove" data-b2b-po-remove>Remove</button>' +
      '</div>' +
      '</div>'
    );
  }

  function isB2bCartItem(item) {
    if (!item || !item.properties) return false;
    var source = item.properties['_Special'] || item.properties._Special || item.properties.Special || item.properties['Special'];
    return source === 'B2B Wholesale';
  }

  function isInCurrentCollection(item) {
    if (!item || !collectionProductIds) return true;
    return collectionProductIds.has(Number(item.product_id));
  }

  function loadCollectionProductIds() {
    if (collectionSearchIndexPromise) return collectionSearchIndexPromise;

    if (!collectionHandle && !collectionUrl) {
      collectionProductIds = new Set();
      collectionSearchIndex = [];
      collectionSearchIndexPromise = Promise.resolve(collectionProductIds);
      return collectionSearchIndexPromise;
    }

    var ids = new Set();
    var index = [];
    var indexByHandle = {};
    var expected = Number(window.b2bCollectionProductsCount) || 0;
    var perPage = 50;
    var totalPages = Math.max(1, expected ? Math.ceil(expected / perPage) : 1);

    function addCardToIndex(card) {
      if (!card) return;
      var handle = card.getAttribute('data-b2b-product-handle');
      if (!handle) return;

      cacheProductCard(card);

      var productId = Number(card.getAttribute('data-b2b-product-id')) || 0;
      if (productId) ids.add(productId);

      if (indexByHandle[handle]) {
        if (!indexByHandle[handle].id && productId) indexByHandle[handle].id = productId;
        return;
      }

      var entry = {
        id: productId,
        handle: handle,
        title: (card.getAttribute('data-b2b-title') || '').trim()
      };
      indexByHandle[handle] = entry;
      index.push(entry);
    }

    function addCardsFromRoot(root) {
      if (!root) return;
      root.querySelectorAll('.b2b-product[data-b2b-product-handle]').forEach(addCardToIndex);
    }

    function finalize() {
      collectionProductIds = ids;
      collectionSearchIndex = index;
      return collectionProductIds;
    }

    function fetchCollectionPage(pageNum) {
      var url = new URL(collectionUrl || ('/collections/' + collectionHandle), window.location.origin);
      if (pageNum > 1) url.searchParams.set('page', String(pageNum));
      url.searchParams.set('section_id', ajaxSectionId);

      return fetch(url.toString(), { credentials: 'same-origin' }).then(function (res) {
        if (!res.ok) throw new Error('Failed to load collection page ' + pageNum);
        return res.text();
      }).then(function (html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;
        addCardsFromRoot(temp);

        if (!expected) {
          var paginationText = temp.querySelector('.b2b-pagination__text');
          if (paginationText) {
            var match = (paginationText.textContent || '').match(/of\s+(\d+)/i);
            if (match) {
              expected = Number(match[1]) || expected;
              totalPages = Math.max(totalPages, Math.ceil(expected / perPage));
            }
          }
        }

        return true;
      });
    }

    // Seed from currently rendered products, then load every collection page
    // using the same ajax section as "Show more" so search matches the catalog.
    addCardsFromRoot(document);

    collectionSearchIndexPromise = fetchCollectionPage(1)
      .then(function () {
        if (totalPages <= 1) return finalize();

        var remaining = [];
        for (var pageNum = 2; pageNum <= totalPages; pageNum++) {
          remaining.push(fetchCollectionPage(pageNum));
        }
        return Promise.all(remaining).then(finalize);
      })
      .catch(function (err) {
        console.error(err);
        // Keep whatever we already seeded from the DOM.
        if (index.length) return finalize();
        collectionProductIds = new Set();
        collectionSearchIndex = [];
        collectionSearchIndexPromise = null;
        return collectionProductIds;
      });

    return collectionSearchIndexPromise;
  }

  function indexProductMatches(product, query) {
    if (!product || !query) return false;
    var title = (product.title || '').trim().toLowerCase();
    var q = String(query).trim().toLowerCase();
    if (!title || !q) return false;
    return title.indexOf(q) !== -1;
  }

  function cardTitleMatches(card, query) {
    if (!card || !query) return false;
    var title = (card.getAttribute('data-b2b-title') || '').trim().toLowerCase();
    var q = String(query).trim().toLowerCase();
    if (!title || !q) return false;
    return title.indexOf(q) !== -1;
  }

  function searchCollectionIndex(query, limit) {
    var q = (query || '').trim().toLowerCase();
    var max = limit || 8;
    if (!q) return [];

    var matches = [];
    for (var i = 0; i < collectionSearchIndex.length; i++) {
      if (matches.length >= max) break;
      if (indexProductMatches(collectionSearchIndex[i], q)) {
        matches.push(collectionSearchIndex[i]);
      }
    }
    return matches;
  }

  function purgeUnrelatedB2bCartItems(cart) {
    if (!cart || !collectionProductIds || !collectionProductIds.size) {
      return Promise.resolve(cart);
    }

    var updates = {};
    (cart.items || []).forEach(function (item) {
      if (isB2bCartItem(item) && !isInCurrentCollection(item)) {
        updates[item.key] = 0;
      }
    });

    if (!Object.keys(updates).length) {
      return Promise.resolve(cart);
    }

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to update cart');
        return res.json();
      })
      .catch(function (err) {
        console.error(err);
        return cart;
      });
  }

  function hydratePoFromCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to load cart');
        return res.json();
      })
      .then(function (cart) {
        var poNote = document.getElementById('b2b-po-note');
        if (poNote) {
          var attrPo =
            (cart.attributes && (cart.attributes['PO#'] || cart.attributes['PO #'] || cart.attributes.po_number)) ||
            '';
          poNote.value = attrPo || cart.note || '';
        }

        var container = getPoItems();
        if (!container) return;

        var b2bItems = (cart.items || []).filter(isB2bCartItem).filter(isInCurrentCollection);
        // If checkout was interrupted before properties were set, fall back to all lines
        if (!b2bItems.length && cart.items && cart.items.length && (cart.note || (cart.attributes && cart.attributes['PO#']))) {
          b2bItems = cart.items.filter(isInCurrentCollection);
        }

        if (!b2bItems.length) return;

        container.innerHTML = '';
        b2bItems.forEach(function (item) {
          var variantId = String(item.variant_id);
          var qty = parseInt(item.quantity, 10) || 0;
          if (!variantId || qty <= 0) return;

          updatePoItem(variantId, qty, {
            title: item.product_title
              ? item.product_title + (item.variant_title && item.variant_title !== 'Default Title' ? ' - ' + item.variant_title : '')
              : item.title,
            image: item.image || '',
            price: item.price,
            compare: item.original_price && item.original_price > item.price ? item.original_price : 0
          });
        });
      })
      .catch(function (err) {
        console.error(err);
      });
  }

  function syncCardsFromPo() {
    var container = getPoItems();
    var qtyMap = {};
    if (container) {
      container.querySelectorAll('[data-b2b-added-id]').forEach(function (item) {
        qtyMap[item.getAttribute('data-b2b-added-id')] = parseInt(item.getAttribute('data-b2b-added-qty'), 10) || 0;
      });
    }

    document.querySelectorAll('[data-b2b-qty]').forEach(function (input) {
      var id = input.getAttribute('data-b2b-variant-id');
      var qty = qtyMap[id] || 0;
      input.value = String(qty);
      var card = input.closest('.b2b-product');
      if (card) syncCardSelectedState(card);
    });
  }

  function getTiers() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-b2b-tier]')).map(function (el) {
      return {
        el: el,
        threshold: (parseInt(el.getAttribute('data-b2b-threshold'), 10) || 0) * currencyRate,
        discount: parseInt(el.getAttribute('data-b2b-discount'), 10) || 0,
        code: (el.getAttribute('data-b2b-d-code') || '').trim()
      };
    }).sort(function (a, b) {
      return a.threshold - b.threshold;
    });
  }

  function getQualifyingTier(subtotalCents) {
    var tiers = getTiers();
    var qualifying = null;
    for (var i = 0; i < tiers.length; i++) {
      if (subtotalCents >= tiers[i].threshold) qualifying = tiers[i];
    }
    return qualifying;
  }

  function calculatePo() {
    var container = getPoItems();
    var items = container ? container.querySelectorAll('[data-b2b-added-id]') : [];
    var subtotal = 0;
    var compareTotal = 0;
    var count = 0;

    items.forEach(function (item) {
      var qty = parseInt(item.getAttribute('data-b2b-added-qty'), 10) || 0;
      var price = parseInt(item.getAttribute('data-b2b-price'), 10) || 0;
      var compare = parseInt(item.getAttribute('data-b2b-compare'), 10) || 0;
      subtotal += price * qty;
      compareTotal += (compare > price ? compare : price) * qty;
      count += qty;
    });

    var qualifying = getQualifyingTier(subtotal);
    var discountPct = qualifying ? qualifying.discount : 0;
    currentDiscountCode = qualifying && qualifying.code ? qualifying.code : null;

    var discountedTotal = discountPct > 0 ? Math.round(subtotal * (100 - discountPct) / 100) : subtotal;
    var tierSaving = subtotal - discountedTotal;
    var rrpSaving = Math.max(0, compareTotal - subtotal);
    var saving = tierSaving + rrpSaving;

    var countEl = document.querySelector('[data-b2b-po-count]');
    if (countEl) countEl.textContent = String(count);

    var subtotalEl = document.querySelector('[data-b2b-subtotal]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(subtotal);

    var savingEl = document.querySelector('[data-b2b-saving]');
    if (savingEl) savingEl.textContent = formatMoney(saving);

    var totalEl = document.querySelector('[data-b2b-total]');
    if (totalEl) totalEl.textContent = formatMoney(discountedTotal);

    var checkoutTotal = document.querySelector('[data-b2b-checkout-total]');
    if (checkoutTotal) checkoutTotal.textContent = formatMoney(discountedTotal);

    var checkoutCompare = document.querySelector('[data-b2b-checkout-compare]');
    if (checkoutCompare) {
      if (subtotal > discountedTotal) {
        checkoutCompare.hidden = false;
        checkoutCompare.textContent = formatMoney(subtotal);
      } else {
        checkoutCompare.hidden = true;
        checkoutCompare.textContent = '';
      }
    }

    var checkoutBtn = document.querySelector('[data-b2b-checkout]');
    if (checkoutBtn) {
      var canCheckout = count > 0 && discountedTotal >= moqCents;
      checkoutBtn.disabled = !canCheckout;
      checkoutBtn.classList.toggle('is-inactive', !canCheckout);
    }

    updateProgress(subtotal, qualifying);
  }

  function updateProgress(subtotalCents, qualifying) {
    var tiers = getTiers();
    var fill = document.querySelector('[data-b2b-progress-fill]');
    var msg = document.querySelector('[data-b2b-progress-msg]');
    if (!fill || !msg) return;

    if (!tiers.length) {
      fill.style.width = '0%';
      msg.textContent = 'Add items to unlock volume discounts';
      return;
    }

    var n = tiers.length;
    // Keep first/last pills inset so they don't clip the track edges
    var minPos = 16;
    var maxPos = 84;
    var positions = [];

    for (var i = 0; i < n; i++) {
      var leftPct = n === 1 ? 50 : minPos + (i / (n - 1)) * (maxPos - minPos);
      positions.push(leftPct);
      tiers[i].el.style.left = leftPct + '%';
      tiers[i].el.classList.toggle('is-reached', subtotalCents >= tiers[i].threshold);

      var pill = tiers[i].el.querySelector('[data-b2b-milestone-pill]');
      if (pill) {
        var dollars = Math.round(tiers[i].threshold / 100);
        pill.textContent = currencySymbol + dollars.toLocaleString('en-US');
      }
    }

    // Map dollar progress onto the same positions as the milestone pills
    var fillPct = 0;
    if (subtotalCents <= 0) {
      fillPct = 0;
    } else if (subtotalCents >= tiers[n - 1].threshold) {
      fillPct = 100;
    } else {
      var prevThreshold = 0;
      var prevPos = 0;
      for (var j = 0; j < n; j++) {
        if (subtotalCents < tiers[j].threshold) {
          var span = tiers[j].threshold - prevThreshold;
          var t = span > 0 ? (subtotalCents - prevThreshold) / span : 0;
          fillPct = prevPos + t * (positions[j] - prevPos);
          break;
        }
        prevThreshold = tiers[j].threshold;
        prevPos = positions[j];
      }
    }
    fill.style.width = Math.max(0, Math.min(100, fillPct)) + '%';

    var next = null;
    for (var k = 0; k < n; k++) {
      if (subtotalCents < tiers[k].threshold) {
        next = tiers[k];
        break;
      }
    }

    if (next) {
      var away = next.threshold - subtotalCents;
      msg.innerHTML =
        'You are ' +
        formatMoney(away) +
        ' away from a <span class="b2b-po__progress-pct">' +
        next.discount +
        '% discount</span>';
    } else if (qualifying) {
      msg.innerHTML =
        'You unlocked a <span class="b2b-po__progress-pct">' +
        qualifying.discount +
        '% discount</span>';
    } else {
      msg.textContent = 'Add items to unlock volume discounts';
    }
  }

  function runCheckout() {
    if (checkoutInFlight) return;
    var container = getPoItems();
    if (!container) return;
    var items = container.querySelectorAll('[data-b2b-added-id]');
    if (!items.length) return;

    var itemsToAdd = [];
    items.forEach(function (item) {
      var id = item.getAttribute('data-b2b-added-id');
      var quantity = parseInt(item.getAttribute('data-b2b-added-qty'), 10) || 0;
      if (id && quantity > 0) {
        itemsToAdd.push({
          id: id,
          quantity: quantity,
          properties: {
            _Special: 'B2B Wholesale'
          }
        });
      }
    });

    if (!itemsToAdd.length) return;

    var poNote = document.getElementById('b2b-po-note');
    var noteValue = poNote ? poNote.value.trim() : '';
    var checkoutBtn = document.querySelector('[data-b2b-checkout]');

    checkoutInFlight = true;
    if (checkoutBtn) {
      checkoutBtn.disabled = true;
      checkoutBtn.classList.add('is-inactive');
    }

    fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to clear cart');
        return res.json();
      })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsToAdd })
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to add items');
        return res.json();
      })
      .then(function () {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            note: noteValue,
            attributes: { 'PO#': noteValue }
          })
        });
      })
      .then(function (res) {
        if (res && !res.ok) throw new Error('Failed to update cart note');
        var checkoutUrl = '/checkout';
        if (currentDiscountCode) {
          checkoutUrl += '?discount=' + encodeURIComponent(currentDiscountCode);
        }
        window.location.href = checkoutUrl;
      })
      .catch(function (err) {
        console.error(err);
        checkoutInFlight = false;
        calculatePo();
        alert('There was an error processing your checkout. Please try again.');
      });
  }

  function getSearchRoot() {
    return document.querySelector('[data-b2b-search]');
  }

  function getSearchInput() {
    return document.querySelector('[data-b2b-search-input]');
  }

  function getSearchResults() {
    return document.querySelector('[data-b2b-search-results]');
  }

  function getSearchClear() {
    return document.querySelector('[data-b2b-search-clear]');
  }

  function setSearchExpanded(open) {
    var input = getSearchInput();
    var results = getSearchResults();
    var root = getSearchRoot();
    if (input) input.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (root) root.classList.toggle('is-open', !!open);
    if (results) results.hidden = !open;
  }

  function closeB2bSearch() {
    if (searchTimer) {
      clearTimeout(searchTimer);
      searchTimer = null;
    }
    if (searchAbort) {
      searchAbort.abort();
      searchAbort = null;
    }
    setSearchExpanded(false);
  }

  function updateSearchClearVisibility() {
    var input = getSearchInput();
    var clearBtn = getSearchClear();
    if (!input || !clearBtn) return;
    clearBtn.hidden = !input.value.trim();
  }

  function getSearchCardsFromHtml(html) {
    var temp = document.createElement('div');
    temp.innerHTML = html;
    var ajax = temp.querySelector('[data-b2b-search-ajax], [data-b2b-product-card-ajax]') || temp;
    return Array.prototype.slice.call(ajax.querySelectorAll('.b2b-product'));
  }

  function renderSearchCards(cards) {
    var results = getSearchResults();
    if (!results) return;

    if (!cards.length) {
      results.innerHTML = '<div class="b2b-search-dropdown__empty">No products found</div>';
      setSearchExpanded(true);
      return;
    }

    results.innerHTML = '';
    cards.forEach(function (card) {
      var clone = card.cloneNode(true);
      clone.classList.add('b2b-search-result');
      clone.hidden = false;
      results.appendChild(clone);
      cacheProductCard(card);
    });
    setSearchExpanded(true);
    syncCardsFromPo();
  }

  function getSearchCardCache() {
    var cache = document.querySelector('[data-b2b-search-card-cache]');
    if (cache) return cache;
    var host = document.querySelector('[data-b2b-shell]') || document.body;
    cache = document.createElement('div');
    cache.setAttribute('data-b2b-search-card-cache', '');
    cache.hidden = true;
    host.appendChild(cache);
    return cache;
  }

  function cacheProductCard(card) {
    if (!card) return;
    var handle = card.getAttribute('data-b2b-product-handle');
    if (!handle) return;
    var cache = getSearchCardCache();
    if (!cache) return;
    if (cache.querySelector('.b2b-product[data-b2b-product-handle="' + handle + '"]')) return;
    var clone = card.cloneNode(true);
    clone.classList.remove('b2b-search-result');
    clone.hidden = true;
    cache.appendChild(clone);
  }

  function getDomSearchCard(handle) {
    if (!handle) return null;
    var selectors = [
      '[data-b2b-catalog] .b2b-product[data-b2b-product-handle="' + handle + '"]:not(.b2b-search-result)',
      '[data-b2b-search-card-cache] .b2b-product[data-b2b-product-handle="' + handle + '"]'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var card = document.querySelector(selectors[i]);
      if (card) return card.cloneNode(true);
    }
    return null;
  }

  function fetchSearchCardByHandle(handle) {
    var url = '/products/' + encodeURIComponent(handle) + '?section_id=' + encodeURIComponent(productCardSectionId);
    return fetch(url, {
      credentials: 'same-origin',
      signal: searchAbort ? searchAbort.signal : undefined
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to load product card');
        return res.text();
      })
      .then(function (html) {
        var cards = getSearchCardsFromHtml(html);
        var card = cards[0] || null;
        if (card) cacheProductCard(card);
        return card;
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') throw err;
        console.error(err);
        return null;
      });
  }

  function fetchSearchCardsByHandles(handles) {
    if (!handles.length) return Promise.resolve([]);

    return Promise.all(
      handles.map(function (handle) {
        return fetchSearchCardByHandle(handle).then(function (card) {
          return { handle: handle, card: card };
        });
      })
    ).then(function (entries) {
      return handles
        .map(function (handle) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].handle === handle && entries[i].card) return entries[i].card;
          }
          return null;
        })
        .filter(Boolean);
    });
  }

  function fetchCatalogSearch(query) {
    var q = (query || '').trim();
    var results = getSearchResults();
    if (!results) return;

    if (!q) {
      results.innerHTML = '';
      setSearchExpanded(false);
      return;
    }

    results.innerHTML = '<div class="b2b-search-dropdown__empty">Searching…</div>';
    setSearchExpanded(true);

    if (searchAbort) searchAbort.abort();
    searchAbort = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var requestId = ++searchRequestId;

    loadCollectionProductIds()
      .then(function () {
        if (requestId !== searchRequestId) return;

        var matches = searchCollectionIndex(q, 8);
        if (!matches.length) {
          results.innerHTML =
            '<div class="b2b-search-dropdown__empty">No products found for “' +
            q.replace(/</g, '&lt;') +
            '”</div>';
          setSearchExpanded(true);
          return;
        }

        var orderedCards = [];
        var missingHandles = [];

        matches.forEach(function (match) {
          var domCard = getDomSearchCard(match.handle);
          if (domCard) {
            orderedCards.push({ handle: match.handle, card: domCard });
          } else {
            missingHandles.push(match.handle);
            orderedCards.push({ handle: match.handle, card: null });
          }
        });

        var renderOrdered = function () {
          if (requestId !== searchRequestId) return;
          var cards = orderedCards
            .map(function (entry) {
              return entry.card;
            })
            .filter(function (card) {
              return card && cardTitleMatches(card, q);
            });
          if (cards.length) {
            renderSearchCards(cards);
          } else {
            results.innerHTML =
              '<div class="b2b-search-dropdown__empty">No products found for “' +
              q.replace(/</g, '&lt;') +
              '”</div>';
            setSearchExpanded(true);
          }
        };

        if (!missingHandles.length) {
          renderOrdered();
          return;
        }

        return fetchSearchCardsByHandles(missingHandles).then(function (fetchedCards) {
          if (requestId !== searchRequestId) return;
          var fetchedByHandle = {};
          fetchedCards.forEach(function (card) {
            var handle = card.getAttribute('data-b2b-product-handle');
            if (handle) fetchedByHandle[handle] = card;
          });
          orderedCards.forEach(function (entry) {
            if (!entry.card && fetchedByHandle[entry.handle]) {
              entry.card = fetchedByHandle[entry.handle];
            }
          });
          renderOrdered();
        });
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        if (requestId !== searchRequestId) return;
        console.error(err);
        results.innerHTML = '<div class="b2b-search-dropdown__empty">Unable to search right now</div>';
        setSearchExpanded(true);
      });
  }

  function scheduleCatalogSearch(query) {
    if (searchTimer) clearTimeout(searchTimer);
    searchTimer = setTimeout(function () {
      fetchCatalogSearch(query);
    }, 220);
  }

  function onReady() {
    restoreView();
    applyInStockFilter();
    initOfferBannerScroll();
    updateSearchClearVisibility();
    updateProgress(0, null);
    loadCollectionProductIds()
      .then(function () {
        return fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (res) {
            if (!res.ok) throw new Error('Failed to load cart');
            return res.json();
          })
          .then(purgeUnrelatedB2bCartItems);
      })
      .then(function () {
        return hydratePoFromCart();
      })
      .then(function () {
        syncCardsFromPo();
        calculatePo();
      });
  }

  function initOfferBannerScroll() {
    var po = document.querySelector('[data-b2b-po]');
    var banner = document.querySelector('[data-b2b-offer-banner]');
    if (!po || !banner) return;

    var onScroll = function () {
      var scrolled = window.scrollY > 8;
      po.classList.toggle('is-scrolled', scrolled);
      document.body.classList.toggle('b2b-scrolled', scrolled);
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  document.addEventListener('click', function (event) {
    var viewBtn = event.target.closest('[data-b2b-view]');
    if (viewBtn) {
      event.preventDefault();
      setView(viewBtn.getAttribute('data-b2b-view'));
      return;
    }

    if (event.target.closest('.b2b-filter-open')) {
      event.preventDefault();
      openFilters();
      return;
    }

    if (event.target.closest('.b2b-filter-close')) {
      event.preventDefault();
      closeFilters();
      return;
    }

    var sortToggle = event.target.closest('.b2b-sort-toggle');
    if (sortToggle) {
      event.preventDefault();
      var menu = document.getElementById('b2b-sort-menu');
      if (menu) {
        var open = menu.hasAttribute('hidden');
        if (open) menu.removeAttribute('hidden');
        else menu.setAttribute('hidden', '');
        sortToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      return;
    }

    if (!event.target.closest('.b2b-toolbar__sort')) {
      var sortMenu = document.getElementById('b2b-sort-menu');
      if (sortMenu && !sortMenu.hasAttribute('hidden')) {
        sortMenu.setAttribute('hidden', '');
        var toggle = document.querySelector('.b2b-sort-toggle');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }
    }

    var sortLink = event.target.closest('.b2b-change-sorting');
    if (sortLink) {
      event.preventDefault();
      var sortValue = sortLink.getAttribute('href');
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortValue);
      fetchCollection(url.toString());
      return;
    }

    var filterLink = event.target.closest('.b2b-change-collection');
    if (filterLink) {
      event.preventDefault();
      fetchCollection(filterLink.href);
      return;
    }

    var nextLink = event.target.closest('a.b2b-next');
    if (nextLink) {
      event.preventDefault();
      var label = nextLink.textContent;
      nextLink.textContent = 'Loading...';
      var requestUrl = buildSectionUrl(nextLink.href);
      fetch(requestUrl)
        .then(function (res) {
          if (!res.ok) throw new Error('Failed to load more');
          return res.text();
        })
        .then(function (html) {
          var temp = document.createElement('div');
          temp.innerHTML = html;
          var newProducts = temp.querySelector('[data-b2b-products]');
          var currentProducts = getProductsRoot();
          if (newProducts && currentProducts) {
            currentProducts.insertAdjacentHTML('beforeend', newProducts.innerHTML);
          }
          var newPagination = temp.querySelector('.b2b-ajax-pagination');
          var currentPagination = document.querySelector('.b2b-ajax-pagination');
          if (newPagination && currentPagination) {
            currentPagination.innerHTML = newPagination.innerHTML;
          }
          restoreView();
          applyInStockFilter();
          syncCardsFromPo();
        })
        .catch(function (err) {
          console.error(err);
          nextLink.textContent = label;
        });
      return;
    }

    var detailTrigger = event.target.closest('[data-b2b-detail-trigger]');
    if (detailTrigger) {
      event.preventDefault();
      var handle = detailTrigger.getAttribute('data-b2b-product-handle');
      var detailCard = detailTrigger.closest('.b2b-product');
      if (handle) {
        closeB2bSearch();
        openB2bDetail(handle, detailCard);
      }
      return;
    }

    if (event.target.closest('[data-b2b-search-clear]')) {
      event.preventDefault();
      var searchInputClear = getSearchInput();
      if (searchInputClear) {
        searchInputClear.value = '';
        searchInputClear.focus();
      }
      updateSearchClearVisibility();
      closeB2bSearch();
      return;
    }

    if (!event.target.closest('[data-b2b-search]')) {
      closeB2bSearch();
    }

    if (event.target.closest('.b2b-detail-close')) {
      event.preventDefault();
      closeB2bDetail();
      return;
    }

    if (event.target.id === 'b2b-detail-overlay') {
      closeB2bDetail();
      return;
    }

    var detailThumb = event.target.closest('[data-b2b-detail-thumb]');
    if (detailThumb) {
      event.preventDefault();
      var paneContentThumb = getDetailPaneContent();
      var index = parseInt(detailThumb.getAttribute('data-b2b-detail-index'), 10) || 0;
      setDetailSlide(paneContentThumb, index);
      return;
    }

    var detailAdd = event.target.closest('[data-b2b-detail-add]');
    if (detailAdd) {
      event.preventDefault();
      var detailVariantId = detailAdd.getAttribute('data-b2b-variant-id');
      updatePoItem(detailVariantId, 1);
      return;
    }

    var detailQtyBtn = event.target.closest('[data-b2b-detail-qty]');
    if (detailQtyBtn) {
      event.preventDefault();
      var detailPanel = detailQtyBtn.closest('[data-b2b-detail-variant-panel]');
      if (!detailPanel) return;
      var detailVarId = detailPanel.getAttribute('data-b2b-variant-id');
      var detailCurrent = getPoQtyForVariant(detailVarId);
      var detailNext =
        detailQtyBtn.getAttribute('data-b2b-detail-qty') === 'inc'
          ? detailCurrent + 1
          : Math.max(0, detailCurrent - 1);
      updatePoItem(detailVarId, detailNext);
      return;
    }

    var swatch = event.target.closest('[data-b2b-swatch]');
    if (swatch) {
      event.preventDefault();
      var cardSwatch = swatch.closest('.b2b-product');
      if (cardSwatch) activateVariant(cardSwatch, swatch.getAttribute('data-b2b-variant-id'));
      return;
    }

    var addBtn = event.target.closest('[data-b2b-add]');
    if (addBtn) {
      event.preventDefault();
      var variantId = addBtn.getAttribute('data-b2b-variant-id');
      var panel = addBtn.closest('[data-b2b-variant-panel]');
      var input = panel ? panel.querySelector('[data-b2b-qty]') : null;
      if (input) input.value = '1';
      updatePoItem(variantId, 1);
      return;
    }

    var qtyBtn = event.target.closest('[data-b2b-qty-change]');
    if (qtyBtn) {
      event.preventDefault();
      var panelQty = qtyBtn.closest('[data-b2b-variant-panel]');
      var qtyInput = panelQty ? panelQty.querySelector('[data-b2b-qty]') : null;
      if (!qtyInput) return;
      var current = parseInt(qtyInput.value, 10) || 0;
      var next = qtyBtn.getAttribute('data-b2b-qty-change') === 'inc' ? current + 1 : Math.max(0, current - 1);
      qtyInput.value = String(next);
      updatePoItem(qtyInput.getAttribute('data-b2b-variant-id'), next);
      return;
    }

    var poQtyBtn = event.target.closest('[data-b2b-po-qty]');
    if (poQtyBtn) {
      event.preventDefault();
      var poItem = poQtyBtn.closest('[data-b2b-added-id]');
      if (!poItem) return;
      var poQty = parseInt(poItem.getAttribute('data-b2b-added-qty'), 10) || 0;
      var poNext = poQtyBtn.getAttribute('data-b2b-po-qty') === 'inc' ? poQty + 1 : Math.max(0, poQty - 1);
      updatePoItem(poItem.getAttribute('data-b2b-added-id'), poNext);
      return;
    }

    var removeBtn = event.target.closest('[data-b2b-po-remove]');
    if (removeBtn) {
      event.preventDefault();
      var removeItem = removeBtn.closest('[data-b2b-added-id]');
      if (removeItem) updatePoItem(removeItem.getAttribute('data-b2b-added-id'), 0);
      return;
    }

    if (event.target.closest('[data-b2b-checkout]')) {
      event.preventDefault();
      runCheckout();
      return;
    }

    if (event.target.closest('.b2b-po-toggle')) {
      var shell = getShell();
      if (shell && window.matchMedia('(max-width: 990px)').matches) {
        shell.classList.toggle('is-po-open');
        document.body.style.overflow = shell.classList.contains('is-po-open') ? 'hidden' : '';
      }
      return;
    }

    var createPo = event.target.closest('.b2b-header__create-po');
    if (createPo) {
      event.preventDefault();
      var shellPo = getShell();
      if (shellPo && window.matchMedia('(max-width: 990px)').matches) {
        shellPo.classList.add('is-po-open');
        document.body.style.overflow = 'hidden';
      }
      var poNoteInput = document.getElementById('b2b-po-note');
      var poNoteWrap = document.querySelector('.b2b-po__note');
      if (poNoteWrap) {
        poNoteWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      if (poNoteInput) {
        setTimeout(function () {
          poNoteInput.focus();
        }, 100);
      }
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target.id === 'b2b-in-stock-only') {
      applyInStockFilter();
      return;
    }

    if (event.target.matches('[data-b2b-variant-select]')) {
      var card = event.target.closest('.b2b-product');
      if (card) activateVariant(card, event.target.value);
      return;
    }

    if (event.target.matches('[data-b2b-detail-variant-select]')) {
      var paneContentSelect = getDetailPaneContent();
      activateDetailVariant(paneContentSelect, event.target.value, activeDetailCard);
      return;
    }

    if (event.target.matches('[data-b2b-qty]')) {
      updatePoItem(event.target.getAttribute('data-b2b-variant-id'), event.target.value);
    }
  });

  document.addEventListener('input', function (event) {
    if (!event.target.matches('[data-b2b-search-input]')) return;
    updateSearchClearVisibility();
    scheduleCatalogSearch(event.target.value);
  });

  document.addEventListener('focusin', function (event) {
    if (!event.target.matches('[data-b2b-search-input]')) return;
    var value = event.target.value.trim();
    var results = getSearchResults();
    if (value && results && results.innerHTML.trim()) {
      setSearchExpanded(true);
    } else if (value) {
      scheduleCatalogSearch(value);
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-b2b-search-form]');
    if (!form) return;
    event.preventDefault();
    var input = form.querySelector('[data-b2b-search-input]');
    if (input) fetchCatalogSearch(input.value);
  });

  window.addEventListener('popstate', function () {
    fetchCollection(window.location.href, false);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var searchRoot = getSearchRoot();
    if (searchRoot && searchRoot.classList.contains('is-open')) {
      closeB2bSearch();
      return;
    }
    closeB2bDetail();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
